﻿import React, { useEffect, useRef } from "react";
import "./zeroaccount.css";
import zeroac from "../../../Images/zero-ac.png";
function zeroaccount() {
    return (
        <>
            <section class="learngrow_section">
                <div class="container">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="zeraccount_img text-left">
                                
                                {/* alt="Zero Charges" updated */}
                                <img className="img-fluid" src={zeroac} alt="Zero Charges"></img>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="zeraccount_text text-left">
                                <h3>Zero Charges</h3>
                                <ul>
                                    <li>0 Account Opening Charges</li>
                                    <li>0 Account Maintenance Charges <small>(For 1st Year only)</small></li>
                                    <li>0  Charges for Research tools</li>
                                    <li>0 Charges for Delivery <small>(Plan A)</small></li>
                                    <li>Flexible brokerage plans</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default zeroaccount;